module.exports = __webpack_public_path__ + "static/media/pencil.c9e0323c.svg";